@if (!loading) {
  <div>
    <app-consult-note-title [patientAttachment]="patientAttachment" />
    <div class="row">
      <div class="col-5">
        <div class="border rounded container-fluid p-0 mb-1">
          <div class="mx-1 row small-gutters">
            <div class="col-auto">
              <strong>CLIENT</strong>
              <div>
                <a routerLink="/capture-admin/client-management/clients/{{patientAttachment.client.id}}">
                  {{ patientAttachment.client.humanizedName }}
                </a>
              </div>
            </div>
            <div class="col-auto">
              <strong>CE-PATIENT</strong>
              <app-patient-name [patient]="patientAttachment.patient" [canViewPatient]=true/>
            </div>
            <div class="col-auto">
              <strong>OFFICE</strong>
              <app-consult-note-office [providerOffice]="patientAttachment.associatedProviderOffice" />
            </div>
          </div>
        </div>
        <h6 class="p-0 mt-3 mb-0 fw-bold text-black">
          RELATED CONSULT NOTES FOR PATIENT & OFFICE
        </h6>
        <a routerLink="/capture-admin/patients/{{patientAttachment.patient.id}}/documents">View all consult notes</a>
        for {{ patientAttachment.patient.fullName }} ({{ patientAttachment.patient.dob | date: 'MM/dd/yyyy' }})
        @if (patientAttachment.relatedPatientAttachments.length > 0) {
          <table class="table table-sm table-bordered table-hover">
            <thead>
              <tr>
                <th class="min-width">ID</th>
                <th>DOCUMENT NAME</th>
              </tr>
            </thead>
            <tbody>
              <tr
                [ngClass]="patientAttachment.listing.id === selectedAttachment?.id ? 'selected' : 'clickable'"
                (click)="onDisplayDocument(patientAttachment.listing.id)" >
                <td class="min-width">{{ patientAttachment.listing.id }}</td>
                <td>{{ patientAttachment.listing | patientAttachmentListingDisplayName }} [CURRENT NOTE]</td>
              </tr>
              @for (document of patientAttachment.relatedPatientAttachments; track document) {
                <tr
                  [ngClass]="document.id === selectedAttachment?.id ? 'selected' : 'clickable'"
                  (click)="onDisplayDocument(document.id)" >
                  <td class="min-width">{{ document.id }}</td>
                  <td>{{ document | patientAttachmentListingDisplayName }}</td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          No related consult notes.
        }
      </div>
      <div class="col-7">
        @if (!selectedLoading) {
          <div>
            <h6 class="p-0 m-0 fw-bold text-black-50">CONSULT NOTE INFORMATION</h6>
            <div class="border rounded container-fluid p-0 mb-2 bg-light">
              <div class="mx-1 row small-gutters">
                <div class="col-auto">
                  <strong>ID</strong>
                  <div>{{ selectedAttachment.id }}</div>
                </div>
                <div class="col-auto">
                  <strong>STATUS</strong>
                  <div>{{ statusOptions[selectedAttachment.status]?.display }}</div>
                </div>
                <div class="col-auto">
                  <strong>OFFICE</strong>
                  <app-consult-note-office [providerOffice]="selectedAttachment.associatedProviderOffice" />
                </div>
              </div>
            </div>
            <h6 class="p-0 m-0 mt-2 fw-bold text-black-50">FAX INFORMATION</h6>
            <div class="border rounded container-fluid p-0 mb-2 bg-light">
              <div class="mx-1 row small-gutters">
                @if (selectedAttachment.inboundFax) {
                  <div class="col-auto">
                    <strong>STATUS</strong>
                    <div>{{ selectedAttachment.inboundFax.status | faxStatus }}</div>
                  </div>
                  <div class="col-auto">
                    <strong>RECEIVED AT</strong>
                    <div>{{ selectedAttachment.inboundFax.receivedAt | date: 'M/d/yyyy h:mm a' }}</div>
                  </div>
                  <div class="col-auto">
                    <strong>PROCESSED AT</strong>
                    <div>{{ selectedAttachment.inboundFax.processedAt | date: 'MM/dd/yyyy  hh:mm a' | blankValueDash }}</div>
                  </div>
                  <div class="col-auto">
                    <strong>PATIENT</strong>
                    @if (selectedAttachment.inboundFax.patient) {
                      <div>{{ selectedAttachment.inboundFax.patient.fullName }}</div>
                      <div class="small text-nowrap">
                        <strong>MRN:</strong> {{ selectedAttachment.inboundFax.patient.mrn }}
                      </div>
                    } @else {
                      <div><app-blank-value-dash /></div>
                    }
                  </div>
                }
                <div class="col-auto">
                  <strong>PRESCRIBER</strong>
                  <app-prescriber-name
                    [linkToProvider]="true"
                    [showSpecialtiesDetails]="true"
                    [provider]="selectedAttachment.provider" />
                </div>
              </div>
            </div>
            @if (!usePdfKitViewer) {
              <app-pdf-file-viewer
                [pdfFile]="selectedAttachment"
                [pdfFileType]="pdfFileType"
                >
                <a
                  routerLink="/capture-admin/consult-notes/{{selectedAttachment.id}}"
                  target="_blank"
                  class="btn btn-sm btn-secondary text-white">
                  Open Consult Note Page
                </a>
              </app-pdf-file-viewer>
            }
            @if (selectedAttachment.id) {
              <div class="row">
                <div class="col-9"></div>
                <div class="col-3 text-end pb-2">
                  @if (usePdfKitViewer) {
                    <a
                      routerLink="/capture-admin/consult-notes/{{selectedAttachment.id}}"
                      target="_blank"
                      class="btn btn-sm btn-secondary text-white">
                      Open Consult Note Page
                    </a>
                  }
                </div>
              </div>
            }
            @if (usePdfKitViewer && selectedAttachment.url) {
              <app-pdfkit-file-viewer
                [pdfFile]="selectedAttachment"
                [pdfFileType]="pdfFileType"
                class="card"
                height="80vh"
                />
            }
          </div>
        } @else {
          <mat-spinner diameter="60" style="margin: auto;" />
        }
      </div>
    </div>
  </div>
} @else {
  <mat-spinner />
}
<ng-template #noOthers> <p>No related consult notes found.</p> </ng-template>
